<template>
  <div>
    <div class="vx-col w-full">
      <ul class="heading-ul mb-3">
        <li>
          <div class="cursor-pointer" @click="goBack">
            <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
          </div>
        </li>
        <li>
          <h3>{{ $t("setup.label.create_group_ticket") }}</h3>
        </li>
      </ul>
    </div>
    <ValidationObserver ref="observer">
      <vx-card>
        <form>
          <div class="vx-row">
            <div class="vx-col sm:w-full lg:w-1/2 md:w-1/2">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('customers.label.title')"
                :key="resetKey"
              >
                <vs-input
                  :label="$t('customers.label.title')"
                  v-model="ticket.title"
                  class="w-full font-semibold mb-2 starlabel"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col sm:w-full lg:w-1/2 md:w-1/2">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.groupName')"
                :key="resetKey"
              >
                <vs-input
                  :label="$t('setup.label.groupName')"
                  v-model="ticket.groupName"
                  class="w-full font-semibold mb-2 starlabel"
                  icon-no-border
                  :danger="false"
                  danger-text="wrong input"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("customers.label.category")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('customers.label.category')"
                  :key="resetKey"
                >
                  <v-select
                    label="mCodeValue"
                    :options="ticketTemplates.problemsDatas"
                    :placeholder="$t('customers.label.SelectCategory')"
                    :reduce="(mCodeValue) => mCodeValue.id"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    v-model="ticket.problemCode"
                    @input="getSubCategory"
                    class="min-w-200 w-full mb-2"
                  >
                    <template v-slot:option="option">{{
                      option.mCodeValue
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("customers.label.sub_category")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('customers.label.sub_category')"
                  :key="resetKey"
                >
                  <v-select
                    label="subCategory"
                    :options="subCategoryItem"
                    :placeholder="$t('customers.label.SelectSubCategory')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    v-model="ticket.subCategory"
                    :reduce="(subCategory) => subCategory.id"
                    @input="setTimeAndPriority"
                    class="min-w-200 w-full mb-2"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col sm:w-full lg:w-1/2 md:w-1/2">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("setup.label.city")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.city')"
                  :key="resetKey"
                >
                  <v-select
                    label="cityName"
                    :options="cityTemplate.cityDatas"
                    :placeholder="$t('setup.label.selectCity')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    v-model="ticket.city"
                    multiple
                    :reduce="(cityName) => cityName.id"
                    class="min-w-200 w-full mb-2"
                  >
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col sm:w-full lg:w-1/2 md:w-1/2">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("setup.label.Services")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.Services')"
                  :key="resetKey"
                >
                  <v-select
                    label="value"
                    :options="serviceTemplates.serviceTypes"
                    :placeholder="$t('setup.label.SelectServices')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    v-model="ticket.serviceValues"
                    multiple
                    :reduce="(cityName) => cityName.id"
                    class="min-w-200 w-full mb-2"
                  >
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col md:w-1/2 w-full pb-5">
              <vs-input
                :label="$t('customers.label.ticket_date')"
                class="w-full font-semibold starlabel"
                readonly
                v-model="ticket.ticketDate"
              />
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <div class="pb-5">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('customers.label.priority')"
                  :key="resetKey"
                >
                  <vs-input
                    :label="$t('customers.label.priority')"
                    v-model="ticket.priority"
                    class="w-full font-semibold mb-2 starlabel"
                    icon-no-border
                    :danger="false"
                    danger-text="wrong input"
                    disabled="true"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <div class="dropdown-with-label">
                <small class="date-label">{{
                  $t("customers.label.source")
                }}</small>
                <v-select
                  label="mCodeValue"
                  :options="ticketTemplates.sourceData"
                  :placeholder="$t('customers.label.SelectSource')"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full mb-2"
                  :reduce="(obj) => obj.name"
                  v-model="ticket.sourceOfTicket"
                />
              </div>
            </div>
            <div class="vx-col sm:w-full lg:w-1/2 md:w-1/2">
              <div v-show="false" class="dropdown-with-label">
                <small class="date-label">{{
                  $t("customers.label.due_time")
                }}</small>
                <flat-pickr
                  :config="configdateTimePicker"
                  class="w-full"
                  disabled
                  v-model="ticket.dueTime"
                />
              </div>
            </div>
            <div class="vx-col sm:w-full lg:w-1/2 md:w-1/2">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("customers.label.description")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('customers.label.description')"
                  :key="resetKey"
                >
                  <vs-textarea
                    class="w-full"
                    v-model="ticket.description"
                    rows="5"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col sm:w-full lg:w-1/2 md:w-1/2">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("setup.label.groupDescription")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.groupDescription')"
                  :key="resetKey"
                >
                  <vs-textarea
                    class="w-full"
                    v-model="ticket.groupDescription"
                    rows="5"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>
          <div class="dual-listbox-wrapper" v-if="showTickets">
            <div class="listbox">
              <div class="listbox-header">
                <h6 class="text-left font-bold">
                  {{ $t("setup.label.AvailableTickets") }}
                </h6>
                <div class="flex items-center gap-2">
                  <vs-checkbox
                    v-model="selectAllSourceTickets"
                    @change="handleSelectAllTickets"
                  >
                    Select All
                  </vs-checkbox>
                </div>
              </div>
              <ul class="listbox-body">
                <li
                  v-for="ticket in filteredSourceGroupTickets"
                  :key="ticket.id"
                  :class="[
                    'listbox-item',
                    selectedSourceTickets.includes(ticket.id) ? 'active' : '',
                  ]"
                  @click="toggleSourceTicket(ticket.id)"
                >
                  TICKET#{{ ticket.id }}
                </li>
              </ul>
            </div>

            <div class="arrow-buttons">
              <button
                class="arrow-button"
                :disabled="!selectedSourceTickets.length"
                @click="moveToTarget"
              >
                <feather-icon icon="ArrowRightIcon" svgClasses="text-dark" />
              </button>
              <button
                class="arrow-button"
                :disabled="!selectedTargetTickets.length"
                @click="moveToSource"
              >
                <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
              </button>
            </div>

            <div class="listbox">
              <div class="listbox-header">
                <h6 class="text-left font-bold">
                  {{ $t("setup.label.SelectedTickets") }}
                </h6>
              </div>
              <ul class="listbox-body">
                <li
                  v-for="ticket in filteredTargetGroupTickets"
                  :key="ticket.id"
                  :class="[
                    'listbox-item',
                    selectedTargetTickets.includes(ticket.id) ? 'active' : '',
                  ]"
                  @click="toggleTargetTicket(ticket.id)"
                >
                  TICKET#{{ ticket.id }}
                </li>
              </ul>
            </div>
          </div>
          <div style="height: 30px"></div>
          <div class="center">
            <span class="ml-1 mr-1">
              <vs-button
                type="border"
                class="footerButton-next"
                style="top: 0px"
                @click="goBack"
                >{{ $t("customers.label.cancel") }}</vs-button
              >
            </span>
            <span class="ml-1 mr-1">
              <vs-button
                @click="addTicket"
                class="footerButton-next"
                style="top: 0px"
                >{{ $t("customers.label.submit") }}</vs-button
              >
            </span>
          </div>
          <div style="height: 20px"></div>
        </form>
      </vx-card>
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { mapState } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ValidationPopup from "@/components/ValidationPopup.vue";
import moment from "moment";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

const ticketObj = {
  dueTime: null,
  priority: null,
  sourceOfTicket: "CRM System",
  problemCode: null,
  subCategory: null,
  description: null,
  status: "OPEN",
  title: "",
  groupDescription: "",
  groupName: "",
  city: null,
  type: "Customer",
  locale: "en",
  dateFormat: "dd MMMM yyyy",
  ticketDate: moment().format("DD MM YYYY HH:mm:ss"),
  ticketURL: "https://smartway.trigital.in/app/#/viewTicket/10",
  ticketURL2: "https://ngb.trigital.in/NGB_Client/app/#/viewTicket/",
  ticketTime: moment().format("HH:mm:ss A"),
  serviceValues: null,
};

export default {
  data() {
    return {
      selectedSourceTickets: [],
      selectedTargetTickets: [],
      searchSource: "",
      searchTarget: "",
      ticketsInit: {},
      warningPopup: false,
      showTickets: false,
      warningText: "",
      errorMessage: "",
      resetKey: 0,
      selectedTargetTicketsArray: [],
      ticket: { ...ticketObj },
      configdateTimePicker: {
        enableTime: true,
        dateFormat: "d m Y H:i:S",
      },
      selectAllSourceTickets: false,
    };
  },
  components: {
    "v-select": vSelect,
    "validation-popup": ValidationPopup,
    ValidationProvider,
    ValidationObserver,
    flatPickr,
  },
  computed: {
    ...mapState({
      ticketTemplates: (state) => state.entity.ticketTemplate,
      subCategoryItem: (state) => state.entity.ticketSubcategory,
      groupTickets: (state) => state.groupTicketing.groupTickets,
      cityTemplate: (state) => state.entity.template.addressData,
      serviceTemplates: (state) => state.serviceProducts.serviceTemplate,
    }),
    filteredSourceGroupTickets() {
      if (!this.searchSource) return this.ticketsInit.sourceTickets;
      return this.ticketsInit.sourceTickets.filter((ticket) =>
        ticket.problemDescription
          .toLowerCase()
          .includes(this.searchSource.toLowerCase())
      );
    },
    filteredTargetGroupTickets() {
      if (!this.searchTarget) return this.ticketsInit.targetTickets;
      return this.ticketsInit.targetTickets.filter((ticket) =>
        ticket.problemDescription
          .toLowerCase()
          .includes(this.searchTarget.toLowerCase())
      );
    },
  },
  methods: {
    goBack(){
      this.$router.go(-1)
    },
    async getTemplate() {
      try {
        await this.$store.dispatch("entity/setTemplate");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    moveToTarget() {
      if (!this.selectedSourceTickets.length) return;

      const selected = this.ticketsInit.sourceTickets.filter((ticket) =>
        this.selectedSourceTickets.includes(ticket.id)
      );

      this.ticketsInit.targetTickets.push(...selected);

      this.ticketsInit.sourceTickets = this.ticketsInit.sourceTickets.filter(
        (ticket) => !this.selectedSourceTickets.includes(ticket.id)
      );

      this.selectedSourceTickets = [];
    },
    async getServiceTemplateFunc() {
      try {
        await this.$store.dispatch("serviceProducts/setServiceTemplate");
      } catch (e) {
        this.$toasted.error(e.message);
      }
    },
    moveToSource() {
      if (!this.selectedTargetTickets.length) return;

      const selected = this.ticketsInit.targetTickets.filter((ticket) =>
        this.selectedTargetTickets.includes(ticket.id)
      );

      this.ticketsInit.sourceTickets.push(...selected);

      this.ticketsInit.targetTickets = this.ticketsInit.targetTickets.filter(
        (ticket) => !this.selectedTargetTickets.includes(ticket.id)
      );

      this.selectedTargetTickets = [];
    },
    initializePlans() {
      const sourceTickets = this.groupTickets || [];
      this.$set(this, "ticketsInit", {
        sourceTickets: [...sourceTickets],
        targetTickets: [],
      });
      this.selectedSourceTickets = [];
      this.selectedTargetTickets = [];
    },
    toggleSourceTicket(id) {
      const idx = this.selectedSourceTickets.indexOf(id);
      if (idx === -1) {
        this.selectedSourceTickets.push(id);
      } else {
        this.selectedSourceTickets.splice(idx, 1);
      }
    },

    toggleTargetTicket(id) {
      const idx = this.selectedTargetTickets.indexOf(id);
      if (idx === -1) {
        this.selectedTargetTickets.push(id);
      } else {
        this.selectedTargetTickets.splice(idx, 1);
      }
    },
    handleSelectAllTickets() {
      if (this.selectAllSourceTickets) {
        this.selectedSourceTickets = this.filteredSourceGroupTickets.map(
          (ticket) => ticket.id
        );
      } else {
        this.selectedSourceTickets = [];
      }
    },
    getDate(date) {
      const d = moment(date, "DD-MM-YYYY HH:mm:ss");
      const formattedDate = d.format("DD MM YYYY HH:mm:ss");
      return formattedDate;
    },
    async getTicketTemplate() {
      try {
        await this.$store.dispatch("entity/setTicketTemplate");
        const TicketDate =
          this.ticketTemplates && this.ticketTemplates.strTicketDate;
        this.ticket.ticketDate = this.getDate(TicketDate);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getSubCategory(categoryId) {
      this.ticket.subCategory = null;
      try {
        if (categoryId) {
          this.$store.dispatch("entity/setTicketSubcategory", categoryId);
        } else {
          this.$store.commit("entity/SET_TICKET_SUBCATEGORY", []);
          this.ticket.subCategory = null;
        }
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    setTimeAndPriority(selectedSubCategory) {
      const subCategoryObj = this.subCategoryItem.find(
        (item) => item.id === selectedSubCategory
      );
      this.ticket.priority = subCategoryObj.priority;
      if (subCategoryObj.timetaken > 0) {
        this.ticket.dueTime =
          subCategoryObj.timetaken * 60 * 60 * 1000 + new Date().getTime();
      } else {
        this.ticket.dueTime = "";
      }
    },
    async getTickets() {
      try {
        const payload = {
          region: (() => {
            const cities = this.cityTemplate.cityDatas.filter((city) =>
              this.ticket.city.includes(city.id)
            );
            return cities.map((c) => c.cityName).join(",");
          })(),
          categoryId: this.ticket.problemCode,
          subCategoryId: this.ticket.subCategory,
        };
        const data = await this.$store.dispatch(
          "groupTicketing/getGroupTickets",
          payload
        );
        if (data && data.data && data.data.length > 0) {
          this.showTickets = true;
          await this.initializePlans();
        } else {
          this.showTickets = false;
        }
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async addTicket() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      try {
        this.selectedTargetTicketsArray =
          this.ticketsInit &&
          this.ticketsInit.targetTickets &&
          this.ticketsInit.targetTickets.map((ticket) => ticket.id);
        const payload = {
          description: this.ticket.description,
          categoryId: this.ticket.problemCode,
          subcategoryId: this.ticket.subCategory,
          severity: this.ticket.priority,
          status: "OPEN",
          groupName: this.ticket.groupName,
          groupDescription: this.ticket.groupDescription,
          title: this.ticket.title,
          affectedRegions: this.ticket.city,
          affectedService: this.ticket.serviceValues,
          dueTime: this.ticket.dueTime,
          ticketIds: this.selectedTargetTicketsArray,
        };
        await this.$store.dispatch("groupTicketing/createGroupTicket", payload);
        await this.$swal({
          title: "Success",
          icon: "success",
          text: "Group Ticket Created Successfully!",
          type: "success",
        });
        this.goBack();
      } catch (e) {
        this.errorMessage = e.message.errors[0].defaultUserMessage.replace(
          "The parameter",
          ""
        );
        this.warningPopup = true;
        this.errors = e.message.errors;
      }
    },
  },
  watch: {
    "ticket.city"() {
      if (
        this.ticket.city &&
        this.ticket.problemCode &&
        this.ticket.subCategory
      ) {
        this.getTickets();
      }
    },
    "ticket.problemCode"() {
      if (
        this.ticket.city &&
        this.ticket.problemCode &&
        this.ticket.subCategory
      ) {
        this.getTickets();
      }
    },
    "ticket.subCategory"() {
      if (
        this.ticket.city &&
        this.ticket.problemCode &&
        this.ticket.subCategory
      ) {
        this.getTickets();
      }
    },
  },
  async mounted() {
    await this.getTicketTemplate();
    await this.getTemplate();
    await this.getServiceTemplateFunc();
    console.log("ticketTemplates", this.ticketTemplates);
  },
};
</script>

<style scoped>
.flatpickr-calendar.open {
  z-index: 999999999999;
}
</style>
<style scoped lang="scss">
.rule-card {
  height: 300px;
  min-width: 250px;
  background-color: cornsilk;
  border: 1px solid #ede4e4;
}
.header-plan {
  margin-left: 2.5rem;
  font-weight: 500;
  font-size: large;
}
.header-text {
  margin-left: 1rem;
  font-weight: 500;
  font-size: medium;
}
.search-box {
  border: 1px solid #c4bfbf;
}
.tag-approval {
  border: 2px solid rgb(14, 140, 224);
  color: rgb(23, 180, 228);
  padding: 5px 10px;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  border-radius: 5px;
  cursor: pointer;
}
.dual-listbox-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding: 20px;
}
.listbox {
  width: -webkit-fill-available;
  height: 300px;
  border: 1px solid #ccc;
  border-radius: 6px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  background: #fff;
  display: flex;
  flex-direction: column;
}
.listbox-header {
  background-color: #2e68b266;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}
.listbox-body {
  overflow-y: auto;
  flex-grow: 1;
  margin: 0;
  padding: 10px;
  list-style: none;
}
.listbox-item {
  padding: 10px;
  cursor: pointer;
  transition: background 0.2s;
}
.listbox-item:hover {
  background-color: #f0f8ff;
}
.listbox-item.active {
  background-color: #e2e9f5;
  font-weight: bold;
}
.arrow-buttons {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.arrow-button {
  padding: 8px;
  border: none;
  background-color: #eee;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  font-size: 0;
}
.arrow-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
